import { render, staticRenderFns } from "./form-status.card.vue?vue&type=template&id=6e45ca4e&"
import script from "./form-status.card.vue?vue&type=script&lang=js&"
export * from "./form-status.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-status.card.vue"
export default component.exports